export default __webpack_public_path__ + "static/media/24-song.71062555.png";